import {EventNames, type EventName} from "../../analytics/event_names";
import {getLS} from "../../helpers/ls";
import OnboardingService from "./onboarding_services";
import {OnboardingActionId} from "./onboarding";

const ACTION_EVENT_MAP: Partial<Record<EventName, OnboardingActionId>> = {
    // Strong value signals
    [EventNames.CHOIR_JOINED]: "choir_joined",
    [EventNames.REHEARSAL_CREATED]: "rehearsal_created",
    [EventNames.CHOIR_MEMBER_INVITED]: "first_member_invited",
    [EventNames.CONTRIBUTION_FLOW_STARTED]: "first_contribution_started",
    [EventNames.CONTRIBUTION_UPLOAD_COMPLETED]: "first_contribution_uploaded",
    [EventNames.CONTRIBUTION_SUBMITTED]: "first_contribution_uploaded",
    [EventNames.SONG_UPLOAD_COMPLETED]: "first_contribution_uploaded",
    [EventNames.PRACTICE_SUBMITTED]: "first_practice_submitted",
    [EventNames.CHOIR_PRACTICE_SUBMITTED]: "first_practice_submitted",
    [EventNames.EXERCISE_DIRECT_GAME_OPENED]: "first_exercise_game_opened",
    [EventNames.CREATE_CHOIR_SUBMITTED]: "choir_created",
    [EventNames.CHOIR_SETLIST_CREATED]: "setlist_created",
    [EventNames.MULTITRACK_PLAYER_OPENED]: "multitrack_opened",
    [EventNames.PROJECT_CREATED]: "project_created",
    [EventNames.PROJECT_APPLICATION_SUBMITTED]: "project_application_submitted",
    [EventNames.PROJECT_ROLE_INVITE_SENT]: "first_project_invite_sent",
    [EventNames.CHALLENGE_CREATED]: "challenge_created",
    [EventNames.CHALLENGE_INTEREST_EXPRESSED]: "challenge_interest_expressed",
    [EventNames.CHALLENGE_ENTRY_SUBMITTED]: "challenge_entry_submitted",

    // Isolated-stem activation should only come from explicit part/stem playback.
    [EventNames.SONG_STEM_PLAYED]: "first_stem_played",
    [EventNames.PRACTICE_CLICKED]: "first_practice_started",
    [EventNames.WHITELIST_ROLE_REQUEST_SUBMITTED]: "first_project_interest_expressed",
    [EventNames.DIRECTOR_ROLE_REQUEST_SUBMITTED]: "first_project_interest_expressed",
};

const sentActions = new Set<OnboardingActionId>();

function isAuthenticated(): boolean {
    return Boolean(getLS("access_token"));
}

export function handleOnboardingAnalyticsEvent(name: EventName): void {
    if (!isAuthenticated()) {
        return;
    }

    const actionId = ACTION_EVENT_MAP[name];
    if (!actionId) {
        return;
    }
    if (sentActions.has(actionId)) {
        return;
    }

    sentActions.add(actionId);
    void OnboardingService.recordMeaningfulAction(actionId, "analytics")
        .then((updated) => {
            window.dispatchEvent(new CustomEvent("vc:onboarding-action-recorded", {detail: updated}));
        })
        .catch(() => {
            sentActions.delete(actionId);
        });
}

export function __resetOnboardingActionBridgeStateForTests(): void {
    sentActions.clear();
}
